import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Form, Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { setError, setSuccessMessage } from '../../../App/ErrorsActions';
import * as BECaller from '../../../../util/apiCaller';
import throttle from '../../../../util/throttle';
import Confirm from '../../../../components/Confirm/Confirm';

import { successFilters, setDates } from '../../ReportActions';

import Close from '../../../../assets/img/close.svg';
import deleteIcon from '../../../../assets/img/delete.svg';
import linkIcon from '../../../../assets/img/link.svg';
import checkCircleIcon from '../../../../assets/img/check-circle.svg';

import './modals.scss';

class Views extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible,
      selected: '',
      q: '',
      loadingViews: false,
      applying: false,
      views: [],
      total: 0
    };

    this.search = throttle(this._search, 500, this);
  }

  _search = q => {
    BECaller.api(`executive/filters/${this.props.stream._id}/views?q=${q}`, 'get').then(
      res => {
        this.setState({
          views: res.data,
          total: res.total
        });
      },
      err => {
        this.props.setError(err);
      }
    );
  };

  deleteView = id => {
    if (!id) {
      this.props.setError('Please select a view');
      return false;
    }

    const views = _.filter(this.state.views, v => {
      return v._id !== id;
    });
    this.setState({ views });

    BECaller.api(`executive/filters/${this.props.stream._id}/views/${id}`, 'delete')
      .then(() => {
        this.search(this.state.q);
      })
      .catch(err => {
        this.props.setError(err);
      });
  };

  handleSearch = e => {
    this.setState({ q: e.target.value }, () => {
      this.search(this.state.q);
    });
  };

  handleCopied = e => {
    this.props.setSuccess('URL copied');
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState({
        q: '',
        selected: '',
        isOpened: true,
        loadingViews: true,
        applying: false
      });

      BECaller.api(`executive/filters/${this.props.stream._id}/views`, 'get').then(
        res => {
          this.setState({
            loadingViews: false,
            views: res.data,
            total: res.total
          });
        },
        err => {
          this.props.setError(err);
        }
      );
    }
  };

  onClose = event => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false
    });
  };

  onConfirm = () => {
    if (!this.state.selected) {
      this.props.setError('Please select a view');
      return false;
    }

    this.setState({
      applying: true
    });
    BECaller.api(`executive/filters/${this.props.stream._id}/views/${this.state.selected}`, 'put').then(
      savedConfig => {
        this.props.updateDates(savedConfig);
        this.props.updateFilters(savedConfig);
        this.setState({
          isOpened: false,
          applying: false
        });
      },
      err => {
        this.setState({
          applying: false
        });
        this.props.setError(err);
      }
    );
  };

  setDates(model, dispatch) {
    if (!model || (!model.customDate && typeof model.dateDiff !== 'number')) {
      model.dateDiff = moment().diff(moment().subtract(3, 'months'), 'day');
    }
  
    let from, to;
    if (model.customDate) {
      from = moment(model.from).startOf('day');
      to = moment(model.to).endOf('day');
    } else {
      to = moment().endOf('day');
      if (model.fixedStartDate) {
        from = moment(model.from).startOf('day');
      } else {
        from = moment()
          .subtract(model.dateDiff, 'day')
          .startOf('day');
      }
    }
  
    dispatch(
      updateDates({
        customDate: model.customDate,
        fixedStartDate: model.fixedStartDate,
        startDate: from,
        endDate: to,
        singleDate: to,
        daysFromStart: to.diff(from, 'days')
      })
    );
  }

  render() {
    var modal = (
      <Modal show={this.state.isOpened} onHide={this.onClose} className='modal-dashboard-view'>
        <Modal.Header>
          <Modal.Title>Apply view</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className='dashboard-view'>
            <div className='dashboard-view-form-wrap'>
              <Form.Group controlId="q" >
                <div className='search-wrap'>
                  <Form.Control 
                    type="text" 
                    name="q" 
                    value={this.state.q} 
                    onChange={this.handleSearch} 
                    placeholder='Search view' />
                </div>
              </Form.Group>
              {!!this.state.views.length && (
                <div className="dashboard-view-list">
                  {this.state.views.map((v, i) => {
                    return (
                      <div
                        key={i}
                        className={`dashboard-view-item ${v._id === this.state.selected ? 'selected' : ''}`}
                        onClick={() => this.setState({ selected: v._id })}
                      >
                        <span className='dashboard-view-name'>{v.name}</span>

                        <CopyToClipboard
                          text={`${window.location.protocol}//${window.location.host}/executive/filters/${this.props.stream._id}/views/${v._id}`}
                          onCopy={this.handleCopied}
                        >
                          <Button variant="light-secondary" size="sm" className='btn-icon'>
                            <img src={linkIcon} alt="link" />
                          </Button>
                        </CopyToClipboard>
                        <Confirm
                          onConfirm={() => this.deleteView(v._id)}
                          body={
                            <p>
                              Are you sure you want to remove <br />
                              <strong>{v.name}</strong> view?
                            </p>
                          }
                          confirmText="Remove"
                          icon={deleteIcon}
                          title="Remove view"
                        >
                          <Button variant="danger" size="sm" className='btn-icon'>
                            <img src={deleteIcon} alt="delete" />
                          </Button>
                        </Confirm>
                      </div>
                    );
                  })}
                </div>
              )}

              {!!this.state.loadingViews && <div className='no_results'>Loading...</div>}

              {!this.state.loadingViews && !this.state.views.length && (
                <div className='no-results'>No results found</div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={!this.state.selected || this.state.applying}
            variant="primary"
            onClick={this.onConfirm}
          >
            <img src={checkCircleIcon} alt='' />
            {this.state.applying ? 'Applying...' : 'Apply'}
          </Button>
          <Button variant="secondary"  onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(setError(err)),
    setSuccess: msg => dispatch(setSuccessMessage(msg, { toastId: 'url_success' })),
    updateFilters: data => dispatch(successFilters(data)),
    updateDates: data => dispatch(setDates(data))
  };
};

const mapStateToProps = state => {
  return {
    stream: state.report.selectedStream,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Views);
